/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Ignore 1 = LogOnly 2 = DisableRule
 */
export type ReviewActionType = 0 | 1 | 2;

export const ReviewActionType = {
  Ignore: 0 as ReviewActionType,
  LogOnly: 1 as ReviewActionType,
  DisableRule: 2 as ReviewActionType,
};
